import { CreateAvatarStoreProvider } from '@/pages/avatar/common/context';
import { AvatarType } from '@/pages/avatar/common/types';
import { AvatarPage } from './AvatarPage';

export const AvatarCreatePage = () => {
    return (
        <CreateAvatarStoreProvider type={AvatarType.Express} allowSelection>
            <AvatarPage />
        </CreateAvatarStoreProvider>
    );
};
